import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=4d536d58&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=js&"
export * from "./ReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d536d58",
  null
  
)

export default component.exports